import { LocationNumbersService } from '../../../services'

const catchTollFreeStatusReq = async (dispatch, locationId) => {
  try {
    await dispatch('fetchPhoneNumbersTollFreeStatus', locationId)
  } catch (error) {
    console.error(error)
  }
}

const fetchLocationTwilio = async function (
  { commit, dispatch, state },
  locationId
) {
  commit('startLoading')

  try {
    await catchTollFreeStatusReq(dispatch, locationId)
    const data = await LocationNumbersService.getDetailedTwilioAccount(
      locationId
    )

    if (!data?.defaultOutboundNumber)
      data.defaultOutboundNumber = state.defaultOutboundNumber

    commit('setLocationTwilio', data)
    commit('setDefaultOutboundNumber', data.defaultOutboundNumber)
    commit(
      'setTotalPhoneNumbers',
      Object.keys(data?.numbers ?? {})?.length ?? 0
    )
    commit('setTotalNumberPools', data?.numberPools?.length ?? 0)
    commit('setNumberPoolIDs', data?.numberPools)
    commit('stopLoading')
    return Promise.resolve(data)
  } catch (error) {
    commit('stopLoading')
    return Promise.reject(error)
  }
}

export default fetchLocationTwilio
